// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","circle":"_3Pjo2","arrow":"r9ch0"};